import { Message } from 'element-ui'

/**
 *  图片加载完成之后得到图片的宽高
 * @param { imageObject } file 图片file
 * @returns promise 返回加载完成之后的promise
 */
const getImageInfoByUrl = (file) => {
  var imageLoadPromise = new Promise((resolve, reject) => {
    let image = new Image();
    image.src = file.url;

    image.onload = function () {
      // 需要将原始图片的大小缓存起来
      file.width = image.width;
      file.height = image.height;

      file.originalWidth = image.width;
      file.originalHeight = image.height;

      resolve(file)
    }
  })
  return imageLoadPromise;
}

/**
* 获取图片的 base64 编码 DataURL
* @param image JS 图像对象
* @return {string} 已编码的 DataURL
*/
const getImageBase64 = (image) => {
  // 创建画布
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext('2d');
  // 以图片为背景剪裁画布
  ctx.drawImage(image, 0, 0, image.width, image.height);
  // 获取图片后缀名
  const extension = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase();
  // 某些图片 url 可能没有后缀名，默认是 png
  return canvas.toDataURL('image/' + extension, 1);
}

const image2Base64 = (imageFile) => {
  var base64Url = "";
  const image = new Image();
  image.src = imageFile.url;
  image.width = imageFile.width;
  image.height = imageFile.height;

  image.onload = () => {
    base64Url = getImageBase64(image);
    imageFile.base64Url = base64Url;
  }
}

/**
 *  对数字进行格式化显示，显示千位分隔符，
 * @param { Number }  data 需要格式化的数据
 * @param { Number }  places 小数点之后保留几位
 * @param { String }  thousand 是否使用千分位分隔符
 * @param { String }  decimal 小数点
 * @returns 
 */
 const formatData = function (data , places, thousand, decimal) {
  places = !isNaN(places = Math.abs(places)) ? places : 2;
  thousand = thousand || ",";
  decimal = decimal || ".";
  var number = data,
    negative = number < 0 ? "-" : "",
    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
};

/**
 * 
 * @param {*} file 
 */
const formatImage = (file, type) => {
  var url = `${file.url}?imageMogr2/format/${type}`;
  return url;
}

const  base64ToBlob = (data) => {
  let contentType = data.split(':')[1];
  let raw = window.atob(data.replace(/^data:image\/(png|jpeg|jpg|webp|bmp);base64,/, ''));
  let rawLength = raw.length;
  let uInt8Array = new Uint8Array(rawLength);
  for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
}

/**
 * 计算图片的大小
 */
const imageSize = (size) => {
  var size_KB = size / 1024, size_MB = size / 1024 / 1024;
  return formatData(size_KB, 2) + 'KB';
}

/**
 * 
 * @param { file } image对象
 * @returns 
 */
// 把image 转换为 canvas对象  
function imgToCanvas(image) {
  var canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  canvas.getContext("2d").drawImage(image, 0, 0);
  return canvas;
}

/**
 * 
 * @param { canvas } canvas 对象
 * @returns 
 */
//canvas转换为image
function canvasToImg(canvas) {
  var array = ["image/jpeg", "image/png"],
      type = document.getElementById('typeSelect').value - 1;
  var src = canvas.toDataURL(array[type]);
  return src;
}

/**
 * 
 * @param { file } file 图片对象
 * @returns 
 */
function readFile (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.raw);
    reader.onload = (arg) => {
      let image = new Image();
      image.src = arg.target.result;
      file.url = arg.target.result;
      image.onload = () => {
        file.width = image.width;
        file.height = image.height;
        file.originalWidth = image.width;
        file.originalHeight = image.height;
        this.setFileList(file);
        resolve(arg);
      }
    };
    reader.onerror = reject;
  });
}

/**
 * 防抖
 */
 let timeout = null
 const debounce = (fn, wait) => {
     if (timeout !== null) clearTimeout(timeout)
     timeout = setTimeout(fn, wait)
 }

const color2Rgb = (colorString) => {
  var sColor = colorString.toLowerCase();
    //十六进制颜色值的正则表达式
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    // 如果是16进制颜色
    if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
            var sColorNew = "#";
            for (var i=1; i<4; i+=1) {
                sColorNew += sColor.slice(i, i+1).concat(sColor.slice(i, i+1));    
            }
            sColor = sColorNew;
        }
        //处理六位的颜色值
        var sColorChange = [];
        for (var i=1; i<7; i+=2) {
            sColorChange.push(parseInt("0x"+sColor.slice(i, i+2)));
        }
        return "RGB(" + sColorChange.join(",") + ")";
    }
    
    return sColor;
}


export default {
  install(Vue) {
    Vue.prototype.$getImageInfoByUrl = getImageInfoByUrl,
    Vue.prototype.$getImageBase64 = getImageBase64,
    Vue.prototype.$image2Base64 = image2Base64,
    Vue.prototype.$formatData = formatData,
    Vue.prototype.$formatImage = formatImage,
    Vue.prototype.$base64ToBlob = base64ToBlob,
    Vue.prototype.$imageSize = imageSize,
    Vue.prototype.$imgToCanvas = imgToCanvas,
    Vue.prototype.$canvasToImg = canvasToImg,
    Vue.prototype.$readFile = readFile,
    Vue.prototype.$debounce = debounce,
    Vue.prototype.$color2Rgb = color2Rgb
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js